import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import recommandation from './modules/recommandation';
import groupe from './modules/groupe';
import * as types from './mutation-type';

Vue.use(Vuex);

export function dateTimeReviver(key, value) {
  let resultRegex;
  if (typeof value === 'string') {
    resultRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/.exec(value);
    if (resultRegex) {
      return new Date(value);
    }
  }
  return value;
}

const store = new Vuex.Store({
  modules: {
    user,
    recommandation,
    groupe,
  },
});

export default store;

export function resetState() {
  ['user', 'recommandation', 'groupe'].forEach((module) => {
    store.commit(module + '/' + types.RESET_STATE);
  });
}
